import { AccountService } from "src/app/services/account.service";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexTitleSubtitle,
  ApexDataLabels,
  ApexFill,
  ApexMarkers,
  ApexYAxis,
  ApexXAxis,
  ApexTooltip,
} from "ng-apexcharts";
import * as moment from "moment";
import { ConfigService } from "src/app/services/config.service";
import { UrlConstants } from "src/app/models/urlConstants";

//import { dataSeries } from './data-series';

@Component({
  selector: "app-new-trade-chart",
  templateUrl: "./new-trade-chart.component.html",
  styleUrls: ["./new-trade-chart.component.scss"],
})
export class NewTradeChartComponent implements OnInit {
  public series: ApexAxisChartSeries;
  public chart: ApexChart;
  public dataLabels: ApexDataLabels;
  public markers: ApexMarkers;
  public title: ApexTitleSubtitle;
  public fill: ApexFill;
  public yaxis: ApexYAxis;
  public xaxis: ApexXAxis;
  public tooltip: ApexTooltip;

  public resultData: any = [];
  public slicedResult: any;
  result: any;
  public companyReuters: string;
  @Input("symbol") symbolCode;

  constructor(
    public httpClient: HttpClient,
    private accService: AccountService
  ) {
    this.getChartData();
    // this.initChartData();
  }

  getChartData() {
    this.resultData = [];
  }

  // CLOSE:5.67
  // HIGH:5.72
  // LOW:5.55
  // OPEN:5.7
  // REUTERS:'ATLC.CA'
  // SYMBOL_CODE:'EGS676N1C015'
  // VALUE_TRADED:0
  // VOLUME_TRADED:257095
  // x:'2021-08-22T00:00:00'

  ngOnChanges(changes: SimpleChanges) {
    this.resultData = [];
    this.symbolCode = changes.symbolCode.currentValue;
    if (this.symbolCode != null) {
      this.getShareGraph(this.symbolCode).subscribe((res) => {
        let responseHistory = res[0].Data;
        this.companyReuters = res[0].Data[0]["REUTERS"];
        for (let item in responseHistory) {
          this.resultData.push({
            date: moment(responseHistory[item]["x"]).format("YYYY-MM-DD"),
            value: [
              responseHistory[item]["OPEN"],
              responseHistory[item]["HIGH"],
              responseHistory[item]["LOW"],
              responseHistory[item]["CLOSE"],
            ],
          });
        }
        this.initChartData(responseHistory[0].REUTERS);
      });
    }
  }

  getShareGraph(symbol) {
    return this.httpClient.post(
      UrlConstants.feedUrl + "/api/Feed/GetSymbolsChart",
      {
        period: "7",
        SYMBOLS_CODE: [this.symbolCode],
        Nth: "-1",
        interval: "1",
      }
    );
  }

  ngOnInit() {}

  public modifyDateSyntax(x) {
    //this.result = x.split('-').join(', ');
    x = x.slice(120);
    let newDate = new Date(this.slicedResult);

    return newDate;
  }

  public initChartData(reuter): void {
    let graphData = [];
    for (let i = 0; i < this.resultData.length; i++) {
      graphData.push([this.resultData[i].date, this.resultData[i].value]);
    }

    this.series = [
      {
        name: reuter,
        data: graphData,
        color: "#d3d3d3",
      },
    ];
    // open,high,low,close
    this.chart = {
      type: "candlestick",
      stacked: false,
      height: 380,
      zoom: {
        type: "x",
        enabled: true,
        autoScaleYaxis: true,
      },
      toolbar: {
        autoSelected: "zoom",
      },
    };
    this.dataLabels = {
      enabled: false,
    };
    this.markers = {
      size: 5,
      colors: ["#09404b"],
    };
    // this.fill = {
    //   type: "gradient",
    //   gradient: {
    //     shadeIntensity: 1,
    //     inverseColors: false,
    //     opacityFrom: 0.8,
    //     opacityTo: 0,
    //     stops: [0, 90, 100],
    //   },
    // };

    this.yaxis = {
      labels: {
        formatter: function (val) {
          return val.toFixed(3).toString();
        },
      },
      title: {
        text: "Price",
      },
    };
    this.xaxis = {
      type: "datetime",
    };
    this.tooltip = {
      shared: false,
      theme: "dark",
      y: {
        formatter: function (val) {
          return val.toFixed(3).toString();
        },
      },
    };
  }
}
